// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import SihaUploadDocumentRequestDTO from '../../dto/request/SihaUploadDocumentRequestDTO';

export default abstract class SihaUploadDocumentRequestModel extends BaseModel<SihaUploadDocumentRequestDTO> {
  // #region    ──FormRequest──────────────────────────╮
  /**
  * @type {binary}
  */
  get uploadFile() { return this.dto.uploadFile; }
  set uploadFile(value) { this.dto.uploadFile = value; }
  // #endregion ───────────────────────────────────────╯
  // #region    ──HeaderRequest──────────────────────────╮
  // #endregion ─────────────────────────────────────────╯
  // #region    ──QueryRequest──────────────────────────╮
  // #endregion ────────────────────────────────────────╯

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
  }
}
